import { Authority, Loading } from "@dataone/lib";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { withAuth } from "../../auth/helpers/hoc";

const ProductTourRedirectPage = () => {
  const productTourPath = useLocation().state?.productTourPath;
  const navigate = useNavigate();

  useEffect(() => {
    if (productTourPath)
      navigate(productTourPath, {
        state: { productTour: productTourPath },
        replace: true,
      });
    else navigate(-1);
  }, []);

  return <Loading />;
};

export default withAuth(ProductTourRedirectPage, [
  Authority.OG_SUBSCRIBER,
  Authority.OG_SUBSCRIBER_EX,
  Authority.OG_ADMIN,
]);
